'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import { nanoid } from 'nanoid';
import { Checkbox } from '../Checkbox/Checkbox.js';
import { usePrevious } from '../../index.js';
export const CheckboxFieldItem = ({ className, id, name, value, checked, disabled, error, onChange, readOnly, text, inverted, }) => {
    const [checkboxChecked, setCheckedState] = React.useState(checked ? checked : false);
    const [idVar, setId] = React.useState();
    const prevChecked = usePrevious(checkboxChecked);
    React.useEffect(() => {
        if (prevChecked !== checkboxChecked) {
            setCheckedState(checkboxChecked);
        }
        setId(id || nanoid());
    }, [id, prevChecked, checkboxChecked]);
    function onInputChange(checked) {
        setCheckedState(!checkboxChecked);
        if (onChange) {
            onChange(checked);
        }
    }
    const componentClassName = classnames('sparky-c-checkbox-field__item', className, {
        'sparky-c-checkbox-field__item--inverted': inverted === true,
        'sparky-is-disabled': disabled === true,
    });
    return (_jsxs("li", Object.assign({ className: componentClassName }, { children: [_jsx(Checkbox, { id: idVar, name: name, value: value, className: "sparky-c-checkbox-field__item-control", checked: checkboxChecked, onChange: onInputChange, error: error, disabled: disabled, readOnly: readOnly, inverted: inverted }), _jsx("label", Object.assign({ className: "sparky-c-checkbox-field__item-label", htmlFor: idVar }, { children: text }))] })));
};
//# sourceMappingURL=CheckboxFieldItem.js.map